// components
require('../membership/membership_manager/js/main');
require('../membership/membership_resident_nag/js/main');
require('../membership/membership_renewal/js/main');
require('../user_area/remember_me_manager/js/main');
require('../user_area/users_manager/js/main');
require('../membership/membership_timeout_popup/js/main');
